import { Component, Input } from '@angular/core';
@Component({
  selector: 'amp-mockup-phone',
  templateUrl: './mockup-phone.component.html',
  styleUrls: ['./mockup-phone.component.scss']
})
export class MockupPhoneComponent {
  @Input() text: string;
  @Input() type: string;
}
